import axios from "axios";
import { useEffect, useState } from "react";
import { FaRegTrashAlt } from "react-icons/fa";
import { FiEdit } from "react-icons/fi";
import { Live_URL } from "../../../config";
import CreateModal from "./components/CreateModal";
import toast, { Toaster } from "react-hot-toast";
import { useForm } from "react-hook-form";
import { uploadCloudinary } from "../../../utils/imageUpload";

const table = ["Image", "Title", "Category", "Short Description", "Content", "Action"]
const AddBlog = () => {
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [limit] = useState(10);
    const [totalItems, setTotalItems] = useState(0);
    const [blogs, setBlogs] = useState([])
    const [categories, setCategories] = useState([]);
    const [isModal, setIsModal] = useState(false);
    const [dataUpdated, setDataUpdated] = useState(false);
    const [editData, setEditData] = useState(undefined);

    const [links, setLinks] = useState([])
    const [isLoading, setIsLoading] = useState(false)

    const [description, setDescription] = useState('');
    const { register, handleSubmit, reset } = useForm({
        defaultValues: {
            name: "",
            short_description: "",
            category: ""
        }
    });

    useEffect(() => {
        if (editData) {
            reset({
                name: editData.name || "",
                short_description: editData.short_description || "",
                category: editData.category || "",
            });
            setDescription(editData?.description || '');
            setLinks(editData?.images || []);
        } else {
            reset({
                name: "",
                short_description: "",
                category: ""
            });
            setDescription('');
            setLinks([]);
        }
    }, [editData, reset]);

    const token = localStorage.getItem("token");

    const fetchCategories = async () => {
        try {
            const res = await axios.get(`${Live_URL}/api/category/name`);
            setCategories(res.data);
        } catch (error) {
            console.error("Failed to fetch categories:", error);
        }
    };

    useEffect(() => {
        const fetchBlogs = async () => {
            try {
                const res = await axios.get(`${Live_URL}/api/blogs`, {
                    params: {
                        page,
                        limit,
                    },
                });
                setBlogs(res.data?.data?.reverse());
                setTotalPages(res.data?.totalPages);
                setTotalItems(res.data?.totalItems);
            } catch (error) {
                console.error("Failed to fetch blogs:", error);
            }
        };

        fetchBlogs();
        fetchCategories();
    }, [page, limit, dataUpdated]);

    useEffect(() => {
        document.title = "Dashboard | Blogs";
    }, [])
    const onSubmit = async (data) => {
        const postData = {
            name: data.name,
            short_description: data.short_description,
            category: data.category,
            description,
            images: links
        };
    
        try {
            let response;
            if (editData?._id) {
                response = await axios.patch(`${Live_URL}/api/blog/${editData._id}`, postData, {
                    headers: { authorization: `Bearer ${token}` },
                });
            } else {
                response = await axios.post(`${Live_URL}/api/blog`, postData, {
                    headers: { authorization: `Bearer ${token}` },
                });
            }
            if (response.status === 200) {
                toast.success("Blog added successfully");
                reset(); // Reset the form
                setDescription(''); // Clear the description
                setIsModal(false); // Close the modal
                setDataUpdated((prev) => !prev); // Trigger data update
                setLinks([])
            } else {
                toast.error("Failed to add product");
            }
        } catch (error) {
            toast.error("Error: " + error.message);
        }
    };
    
    const handleUpdateById = (id) => {
        const findProduct = blogs?.find((c) => c?._id === id);
        setIsModal(true)
        setEditData(findProduct)
        setLinks(findProduct?.images)
        setDescription(findProduct?.description)
    }
    const handleDeleteById = async (id) => {
        try {
            const response = await axios.delete(`${Live_URL}/api/blog/${id}`, {
                headers: { authorization: `Bearer ${token}` },
            });
            if (response.status === 200) {
                toast.success("Deleted successfully");
                setDataUpdated((prev) => !prev);
                await axios.delete(`${Live_URL}/api/comment/${id}`);
            } else {
                toast.error("Failed to delete");
            }
        } catch (error) {
            toast.error("Error deleting:", error);
        }
    }

      const handleFileChange = async (e) => {
        try {
          const selectedFiles = Array.from(e.target.files);
          setIsLoading(true);
          let arr = [];
    
          // Upload each file to Cloudinary
          for (let i = 0; i < selectedFiles.length; i++) {
            const data = await uploadCloudinary(selectedFiles[i]);
            arr.push(data);
          }
    
          // Update the links state with the URLs of the uploaded images
          setLinks((prevLinks) => [...prevLinks, ...arr]);
          setIsLoading(false);
        } catch (error) {
          setIsLoading(false);
        }
      };

      const handleRemoveFile = async (publicId) => {
        try {
          const response = await axios.delete(`${Live_URL}/api/deleteImage`, {
            data: { publicId },
          });
          if (response.status === 200) {
            const filterImage = links.filter((link) => link.publicId !== publicId);
            setLinks(filterImage);
            toast.success("Image deleted successfully");
          } else {
            toast.error("Failed to delete image");
          }
        } catch (error) {
          toast.error("Error deleting image:", error);
        }
      };
    return (
        <div className="mx-4">
            <button onClick={() => {
                setIsModal(true)
                setEditData(undefined)
            }}
                className="bg-mainColor text-white btn text-lg hover:bg-darkColor rounded-lg"
            >
                Add New Post
            </button>
            <div className="overflow-x-auto  shadow  mt-4 rounded-md bg-white">
                <table className="table table-sm">
                    <thead>
                        <tr>
                            {table.map(item => (
                                <th key={item} className="font-semibold text-lg">{item}</th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        <>
                            {blogs?.length > 0 ? (
                                blogs.map((blog) => (
                                    <tr key={blog._id} className="text-lg">
                                        <td>
                                            <div className="flex items-center gap-3">
                                                <div className="avatar">
                                                    <div className="mask rounded w-16 ">
                                                        <img
                                                            className="object-cover"
                                                            src={blog?.images?.[0]?.url}
                                                            alt="Photo"
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </td>
                                        <td>{blog?.name}</td>
                                        <td>{blog?.category}</td>
                                        <td>{blog?.short_description}</td>
                                        <td>{blog?.description.length > 60 ? blog?.description.slice(0, blog?.description.slice(0, 60).lastIndexOf(' ')) + '...' : blog?.description}</td>
                                        <td className="flex gap-2 items-center">
                                            <button
                                                onClick={() => handleUpdateById(blog?._id)}
                                                className="text-green-700 bg-green-200 p-2 rounded-md text-xl"
                                            >
                                                <FiEdit />
                                            </button>
                                            <button
                                                onClick={() => handleDeleteById(blog?._id)}
                                                className="text-red-700 bg-red-200 p-2 rounded-md text-xl"
                                            >
                                                <FaRegTrashAlt />
                                            </button>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="6" className="m-4 text-xl text-center">No Reacord Found</td>
                                </tr>
                            )}
                        </>
                    </tbody>
                </table>
            </div>
            {blogs?.length > 0 && (
                <div className="flex justify-between items-center mt-4">
                    <button
                        className="btn btn-primary"
                        disabled={page === 1}
                        onClick={() => setPage(page - 1)}
                    >
                        Previous
                    </button>
                    <span>
                        Page {page} of {totalPages} - Total Items: {totalItems}
                    </span>
                    <button
                        className="btn btn-primary"
                        disabled={page === totalPages}
                        onClick={() => setPage(page + 1)}
                    >
                        Next
                    </button>
                </div>
            )}
            <CreateModal
                isModal={isModal}
                setIsModal={setIsModal}
                onSubmit={onSubmit}
                categories={categories}
                description={description}
                setDescription={setDescription}
                handleSubmit={handleSubmit(onSubmit)}
                register={register}
                links={links}
                handleRemoveFile={handleRemoveFile}
                isLoading={isLoading}
                handleFileChange={handleFileChange}
            />
            <Toaster />
        </div>
    )
}

export default AddBlog;